import { IntegrationRequestStepId, type IntegrationRequestStep } from '../../../models/IntegrationRun';

type Detail = Record<string, unknown> | null | undefined;

const list = (value: unknown): unknown[] => (Array.isArray(value) ? value : []);

export const describeStepDetail = (step: IntegrationRequestStep): string[] => {
  const detail = step.detail as Detail;
  if (!detail) return [];

  switch (step.id) {
    case IntegrationRequestStepId.BRANCH_CODES: {
      const assignments = list(detail.assignments) as {
        name: string;
        externalBranchCode: string;
        apiCode: string | null;
      }[];
      return assignments.length
        ? assignments.map(
            (item) =>
              `${item.name}: código ${item.externalBranchCode}${item.apiCode ? ` (${item.apiCode})` : ' (sin api_code: ya lo usa otra sucursal)'}`
          )
        : ['Todas las sucursales ya tenían código'];
    }
    case IntegrationRequestStepId.PREPARE:
      return list(detail.actions).map(String);
    case IntegrationRequestStepId.WEBHOOK_APPLY: {
      if (typeof detail.reason === 'string') return [detail.reason];
      return [
        ...(typeof detail.url === 'string' ? [`URL: ${detail.url}`] : []),
        ...list(detail.created).map((status) => `Crea: ${status}`),
        ...list(detail.updated).map((status) => `Actualiza: ${status}`),
      ];
    }
    case IntegrationRequestStepId.SYNC_TEST: {
      const plan = (detail.plan ?? {}) as { creates?: string[]; updates?: string[] };
      return [
        ...(plan.creates ?? []).map((item) => `Crea: ${item}`),
        ...(plan.updates ?? []).map((item) => `Actualiza: ${item}`),
        ...list(detail.missingDependencies).map(String),
        ...list(detail.conflicts).map(String),
      ];
    }
    case IntegrationRequestStepId.VERIFY_TEST: {
      const differences = list(detail.differences).map(String);
      return differences.length ? differences : ['Test quedó igual que producción'];
    }
    case IntegrationRequestStepId.SMOKE_TESTS:
      return (list(detail.results) as { name: string; status: number | null; state: string; ms: number }[]).map(
        (result) =>
          `${result.state === 'ok' ? '✓' : '✗'} ${result.name} — ${result.status ?? 'sin respuesta'} (${result.ms} ms)`
      );
    default: {
      const reason = detail.reason;
      return typeof reason === 'string' ? [reason] : [];
    }
  }
};
